import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgArrowLeft = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20 12a.853.853 0 0 1-.86.846H7.003l4.75 4.46c.344.322.356.86.028 1.195a.87.87 0 0 1-1.214.03l-6.299-5.92a.83.83 0 0 1-.267-.61c0-.233.096-.452.266-.614l6.299-5.918a.87.87 0 0 1 1.215.03.835.835 0 0 1-.03 1.196l-4.748 4.46h12.17c.474 0 .828.38.828.845"
    }));
export default SvgArrowLeft;
